import { Alert, AlertDescription, AlertIcon, Input } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';

// simple integer input field that only accepts integers
// this allows free form input but only fires onChange when the input is a valid integer
// renders red border when the input is invalid
type IntegerInputFieldProps = {
  value: string | number;
  onChange: (value: number) => void;
};
export const IntegerInputField = ({
  value,
  onChange,
}: IntegerInputFieldProps) => {
  const [currentValue, setCurrentValue] = useState<string>(String(value));
  const [isInvalid, setIsInvalid] = useState<boolean>(
    Number.isInteger(Number(value)),
  );

  const isValid = (v: string | number) => Number.isInteger(Number(v));

  useEffect(() => {
    setCurrentValue(String(value));
    setIsInvalid(!isValid(value));
  }, [value]);

  // when input is invalid render red border
  const otherProps = isInvalid
    ? {
        focusBorderColor: 'red.500',
        borderWidth: '1px',
      }
    : {};
  return (
    <>
      <Input
        isInvalid={isInvalid}
        {...otherProps}
        errorBorderColor="red.500"
        value={currentValue}
        onChange={(e) => {
          e.stopPropagation();
          setCurrentValue(e.target.value);
          const newValue = e.target.value;
          const isNewValueValid = isValid(newValue);
          setIsInvalid(!isNewValueValid);
          if (isNewValueValid) {
            onChange(Number(newValue));
          }
        }}
      />
      {isInvalid && (
        <Alert status="error">
          <AlertIcon />
          <AlertDescription>Please enter a valid integer.</AlertDescription>
        </Alert>
      )}
    </>
  );
};
